import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, BriefcaseIcon, LayersIcon, ArrowUpRightIcon } from 'lucide-react';
import { industries } from '../../data/industries';
import { postedLabel } from '../../utils/format';
import { SampleTag } from '../ui/SampleTag';
import type { Job } from '../../types/content';
export function JobCard({
  job
}: {
  job: Job;
}) {
  const industry = industries.find(i => i.slug === job.industry)?.name;
  return <article className="group relative flex h-full flex-col rounded-lg border border-line bg-white p-6 transition-[border-color,box-shadow,transform] duration-200 ease-premium hover:-translate-y-0.5 hover:border-gold/60 hover:shadow-soft" data-id="element-344" data-mp="2xn78tny2ltrm">
      <div className="flex items-center justify-between gap-3" data-id="element-345" data-mp="31qwua4jg7v8f">
        <div className="flex items-center gap-2" data-id="element-346" data-mp="31pc38owceufb">
          <SampleTag data-id="element-347" data-mp="2e09l7fxsqzka" />
          {job.featured && <span className="text-[11px] font-medium text-royal" data-id="element-348" data-mp="2dz7xaavomil5">Featured</span>}
        </div>
        <span className="text-xs text-muted" data-id="element-349" data-mp="29xweopb86xmg">{postedLabel(job.posted)}</span>
      </div>
      <h3 className="mt-5 font-display text-2xl font-semibold leading-snug text-ink" data-id="element-350" data-mp="2yk7vrhnga146">
        <Link to={`/jobs/${job.id}`} className="after:absolute after:inset-0 after:rounded-lg focus-visible:outline-none" data-id="element-351" data-mp="33hzy75lq15mm">
          {job.title}
        </Link>
      </h3>
      <p className="mt-1 text-sm text-gold-700" data-id="element-352" data-mp="3d9nj0nnrvof4">{industry}</p>
      <p className="mt-3 line-clamp-2 text-[15px] leading-relaxed text-muted" data-id="element-353" data-mp="3db8dkda377cz">{job.summary}</p>
      <ul className="mt-auto flex flex-wrap gap-x-4 gap-y-2 pt-6 text-sm text-ink/80" data-id="element-354" data-mp="2fnzyp14lcwjy">
        <li className="flex items-center gap-1.5" data-id="element-355" data-mp="2kmt1nzm9555v">
          <MapPinIcon className="h-4 w-4 text-muted" aria-hidden="true" data-id="element-356" data-mp="2pjjrvfrrth50" />
          {job.location} · {job.arrangement}
        </li>
        <li className="flex items-center gap-1.5" data-id="element-357" data-mp="2ukh7plpb5z3c">
          <BriefcaseIcon className="h-4 w-4 text-muted" aria-hidden="true" data-id="element-358" data-mp="4tuc90j8trb9" />
          {job.type}
        </li>
        <li className="flex items-center gap-1.5" data-id="element-359" data-mp="9s5lpa5mlzsy">
          <LayersIcon className="h-4 w-4 text-muted" aria-hidden="true" data-id="element-360" data-mp="9urwrjrq6xfx" />
          {job.seniority}
        </li>
      </ul>
      <span className="mt-5 flex items-center gap-1 border-t border-line pt-4 text-sm font-medium text-royal" data-id="element-361" data-mp="20wpcwqdhhwej">
        View role details
        <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-362" data-mp="2evgqmbofpg25" />
      </span>
    </article>;
}